import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Select, message } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;

var DAY_FORMAT = "YYYY-MM-DD";

var getRanges = function() {
  return {
    "Hoje": [moment(), moment()],
    "Últimos 7 dias": [moment().subtract(7, 'days'), moment()],
    "Últimos 30 dias": [moment().subtract(30, 'days'), moment()],
    "Este mês": [moment().startOf('month'), moment().endOf('month')],
    "Mês passado": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    "Últimos 3 meses": [moment().subtract(3, 'months').startOf('month'), moment()],
    "Últimos 6 meses": [moment().subtract(6, 'months').startOf('month'), moment()],
    "Este ano": [moment().startOf('year'), moment().endOf('year')],
    "Ano passado": [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
    "Ano retrasado": [moment().subtract(2, 'year').startOf('year'), moment().subtract(2, 'year').endOf('year')],
  };
};

var toRange = function(from, to) {
  return [moment(from, DAY_FORMAT), moment(to, DAY_FORMAT)];
};

/**
 * Table view period form ("Filtrar por" + "Período" + Filtrar). Same layout
 * as the shared AdvancedFilter, but controlled by the page's applied
 * (persisted) values: the fields are a draft until "Filtrar", and follow the
 * applied values when they change elsewhere (pill removed, "Limpar tudo").
 *
 * Props: from, to ('YYYY-MM-DD'), filterBy, filterByOptions, onSubmit({ from, to, filterBy }), style
 */
var PeriodFilter = function(props) {
  var [draftFilterBy, setDraftFilterBy] = useState(props.filterBy);
  var [draftRange, setDraftRange] = useState(toRange(props.from, props.to));

  useEffect(function() {
    setDraftFilterBy(props.filterBy);
  }, [props.filterBy]);

  useEffect(function() {
    setDraftRange(toRange(props.from, props.to));
  }, [props.from, props.to]);

  var handleSubmit = function(e) {
    e.preventDefault();
    if (!draftRange || !draftRange[0] || !draftRange[1]) {
      message.warning('Por favor, selecione um período!');
      return;
    }
    props.onSubmit({
      from: draftRange[0].format(DAY_FORMAT),
      to: draftRange[1].format(DAY_FORMAT),
      filterBy: draftFilterBy,
    });
  };

  var filterByOptions = props.filterByOptions || [];

  return (
    <div style={props.style || {}}>
      <Form
        layout="inline"
        className="ant-advanced-search-form-inline"
        onSubmit={handleSubmit}
      >
        {filterByOptions.length > 0 && (
          <Form.Item label="Filtrar por:">
            <Select value={draftFilterBy} onChange={setDraftFilterBy} style={{ minWidth: '150px' }}>
              {filterByOptions.map(function(option) {
                return (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        )}
        <Form.Item label="Período:" required>
          <RangePicker
            format="DD/MM/YYYY"
            value={draftRange}
            onChange={setDraftRange}
            ranges={getRanges()}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Filtrar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PeriodFilter;
